import { PropsCell } from '../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  {
    id: 'properties_nid',
    numeric: false,
    disablePadding: false,
    label: 'Propiedad',
  },
  { id: 'type_keys_str', numeric: false, disablePadding: false, label: 'Tipo' },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Código',
    center: true,
  },
  {
    id: 'status_keys_id',
    numeric: false,
    disablePadding: false,
    label: 'Estatus',
  },
  {
    id: 'created_at',
    numeric: false,
    disablePadding: false,
    label: 'Fecha de creación',
  },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'id', name: 'Id de llave' },
  { key: 'properties_nid', name: 'Propiedad / NID' },
  { key: 'barcode', name: 'Código de barras' },
  { key: 'status_keys_id', name: 'Estatus' },
  { key: 'type_keys_id', name: 'Tipo de llave' },
];

export const valuesEstatus = [
  { key: '1', name: 'En inventario' },
  { key: '2', name: 'Prestada' },
  { key: '3', name: 'Extraviada' },
  { key: '4', name: 'Dada de baja' },
  { key: '5', name: 'Bloqueada | Transferencia' },
];
